var React = require('react');

function StepCircle0960px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M30 58c15.464 0 28-12.536 28-28S45.464 2 30 2 2 14.536 2 30s12.536 28 28 28zm0 2c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm-5.184-17.604v-1.584c.684.072 1.584 0 2.664-.18 1.908-.288 3.672-1.224 5.076-2.736 1.548-1.656 2.736-4.032 3.168-7.416l-.108.036c-1.476 1.908-3.528 3.024-6.048 3.024-4.356 0-6.66-3.42-6.66-7.092 0-4.32 2.952-8.244 7.488-8.244 4.032 0 7.056 3.42 7.056 9.756 0 5.292-1.836 8.928-3.996 11.088-1.512 1.584-3.636 2.664-5.472 3.024-1.26.252-2.376.36-3.168.324zm5.292-22.752h-.036c-3.204 0-5.436 2.844-5.436 6.696 0 3.456 2.16 5.724 5.256 5.724 2.484 0 4.536-1.296 5.544-3.024.144-.288.324-.612.324-1.044 0-4.932-1.836-8.352-5.652-8.352z"}));
}

StepCircle0960px.displayName = "StepCircle0960px";

StepCircle0960px.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = StepCircle0960px;

StepCircle0960px.default = StepCircle0960px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/step-circle-09-60px.svg
// module id = 1214
// module chunks = 0